import DropdownItem from './DropdownItem';
import { DropdownItemProps, DropdownItemValueProps } from './types';

export type { DropdownItemProps, DropdownItemValueProps };
export default DropdownItem;
